import {
  primitives,
  Primitives,
} from "@/styles/nawy-theme/foundation/colors/primitives";
import {
  typography,
  Typography,
} from "@/styles/nawy-theme/foundation/typography";
import { createTheme } from "@mui/material/styles";
import {
  semantic,
  Semantic,
} from "@/styles/nawy-theme/foundation/colors/semantic";
import { elevation, Elevation } from "@/styles/nawy-theme/foundation/elevation";
import { radius, Roundness } from "@/styles/nawy-theme/foundation/radius";
import { spacing, Spacing } from "@/styles/nawy-theme/foundation/spacing";

// --- Extend the MUI Theme types to include nawy wrapper with all theme properties
declare module "@mui/material/styles" {
  interface Theme {
    nawy: {
      colors: {
        primitives: Primitives;
        semantic: Semantic;
      };
      typography: Typography;
      spacing: Spacing;
      radius: Roundness;
      elevation: Elevation;
    };
  }

  interface BreakpointOverrides {
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobile: true;
    tablet: true;
    desktop: true;
  }
  interface ThemeOptions {
    nawy?: {
      colors?: {
        primitives?: Primitives;
        semantic?: Semantic;
      };
      typography?: Typography;
      spacing?: Spacing;
      radius?: Roundness;
      elevation?: Elevation;
    };
  }
}

export const nawyTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none !important" as "none",
        },
      },
    },
  },
  typography: {
    fontFamily: typography.english.fontFamily,
  },
  nawy: {
    colors: {
      primitives,
      semantic,
    },
    // Spread English variants at top level so @nawy/ui components can resolve
    // theme.nawy.typography.variants.body.
    typography: {
      ...typography,
      fontFamily: typography.english.fontFamily,
      variants: typography.english.variants,
    } as Typography,
    spacing,
    radius,
    elevation,
  },
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 744,
      desktop: 1280,
    },
  },
});
